module.exports = __webpack_public_path__ + "img/thumbs-up.a7e722ba.svg";